import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { voivodeshipListActions } from '../actions/voivodeship-list.actions';
import { selectVoivodeships, selectVoivodeshipsLoaded, selectVoivodeshipsLoading } from '../selectors/voivodeship-list.selector';

@Injectable({ providedIn: 'root' })
export class VoivodeshipsFacade {
    private readonly store = inject(Store);

    readonly voivodeship = this.store.selectSignal(selectVoivodeships);
    readonly loaded = this.store.selectSignal(selectVoivodeshipsLoaded);
    readonly loading = this.store.selectSignal(selectVoivodeshipsLoading);

    readonly voivodeship$ = this.store.select(selectVoivodeships);
    readonly loaded$ = this.store.select(selectVoivodeshipsLoaded);
    readonly loading$ = this.store.select(selectVoivodeshipsLoading);

    getVoivodeships(): void {
        this.store.dispatch(voivodeshipListActions.getVoivodeshipList());
    }

    clear(): void {
        this.store.dispatch(voivodeshipListActions.clear());
    }
}
